export const labelColors = [
  {
    id: "yellow",
    name: "Gelb",
    hex: "#FFD700",
  },
  {
    id: "red",
    name: "Rot",
    hex: "#FF0000",
  },
  {
    id: "green",
    name: "Grün",
    hex: "#008000",
  },
  {
    id: "blue",
    name: "Blau",
    hex: "#0000FF",
  },
] as const;